export const INITIAL_INQUIRIES_FIELD_NAME =
  'value.data.breeder_profiles_initial_inquiries';

export const FORM_ACCOUNT_FIRST_NAME = 'account.first_name';
export const FORM_ACCOUNT_LAST_NAME = 'account.last_name';
export const FORM_ACCOUNT_PHONE_NUMBER = 'account.phone_number';
export const FORM_ACCOUNT_EMAIL = 'account.email';
export const FORM_ACCOUNT_PASSWORD = 'account.password';

export const FORM_MESSAGE_TEXT_NAME = 'conversation_message.message_text';

export const FORM_BREEDER_PROFILE_ID_NAME = 'with.breeder_profile_id';

export const BUTTON_SEND_REQUEST_LABEL = 'Send request';
export const BUTTON_CONTINUE_LABEL = 'Continue';

export const ERROR_MESSAGE_GENERIC = 'An error has occurred. Please try again.';
export const ERROR_MESSAGE_ALREADY_APPLIED =
  'Youʼve already applied to this breeder.';

export const QUIZ_QUESTION_INTRO = 'initial-inquiry-intro';
export const QUIZ_QUESTION_BUYER_NAME = 'buyer-name';
export const QUIZ_QUESTION_BUYER_PHONE_NUMBER = 'buyer-phone';
export const QUIZ_QUESTION_BUYER_EMAIL = 'buyer-email';
export const QUIZ_QUESTION_BUYER_PASSWORD = 'buyer-password';
